import { render, staticRenderFns } from "./articleAssistant.vue?vue&type=template&id=0612a169&scoped=true"
import script from "./articleAssistant.vue?vue&type=script&lang=js"
export * from "./articleAssistant.vue?vue&type=script&lang=js"
import style0 from "./articleAssistant.vue?vue&type=style&index=0&id=0612a169&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612a169",
  null
  
)

export default component.exports